// 大きい獣と重なった主人公を読みやすくする比較版 (DEV `?overlapRead=rim|thin`・2026-11-04)。既定 (指定なし) = 配布版のまま。
//   見えない監査 (11-04) の「大きい獣が主人公に重なって見えなくなる」を等速で確かめた結果 (docs/research/2026-11-04-blind-audit-offscreen-overlap.md):
//   02 戴冠獣・06 覚醒獣とも主人公は獣の手前に描かれていて隠れはしないが、黒い服と髪が黒い毛に溶け、顔とレイピアしか読めない。
//   重なっている時間は戦いの 16〜18%。
//     rim  = 重なった間だけ、主人公の形の外側に薄い月光色の縁 (死の一拍の比較版 ?deathFront=1 と同じ縁)。
//     thin = 重なった間だけ、獣を少し透かす (奥の床と壁が主人公の後ろに見える)。
//   どちらも獣から離れると元に戻る。重なりの強さは横の距離だけで決める (時間でなく位置なので、ちらつかない)。
export type OverlapReadMode = 'off' | 'rim' | 'thin'
let mode: OverlapReadMode = 'off'
/** DEV の切り替え (game.ts)。 */
export function setOverlapRead(v: string | null): OverlapReadMode { mode = v === 'rim' || v === 'thin' ? v : 'off'; return mode }
export function overlapReadMode(): OverlapReadMode { return mode }

// 対象の獣と、体の半分の幅 (この距離より近いと重なり始める)。
const BEAST_HALF_W: Record<string, number> = { 'dream-hound': 150, 'crowned-king-awoken': 150 }
// 重なり始めてから全部効くまでの距離。
const RAMP_PX = 50
// thin で一番透かした時の獣の濃さ。
export const OVERLAP_THIN_ALPHA = 0.62

/** 重なりの強さ 0..1。対象の獣でない・旗が無い時は 0。 */
export function overlapStrength(bossId: string | undefined, playerX: number, bossX: number): number {
  if (mode === 'off' || !bossId) return 0
  const half = BEAST_HALF_W[bossId]
  if (!half) return 0
  return Math.max(0, Math.min(1, (half - Math.abs(playerX - bossX)) / RAMP_PX))
}

/** rim の縁の濃さ (drawPlayer の deathRim と同じ尺度)。 */
export function overlapRimStrength(bossId: string | undefined, playerX: number, bossX: number): number {
  return mode === 'rim' ? overlapStrength(bossId, playerX, bossX) : 0
}

/** thin の獣の濃さ (1 = そのまま)。 */
export function overlapBossAlpha(bossId: string | undefined, playerX: number, bossX: number): number {
  return mode === 'thin' ? 1 - (1 - OVERLAP_THIN_ALPHA) * overlapStrength(bossId, playerX, bossX) : 1
}
